import mousetrap, { ExtendedKeyboardEvent } from 'mousetrap';
import { useEffect, useRef } from 'react';

type Keys = string | string[] | null;
type Callback = (e: ExtendedKeyboardEvent, combo: string) => any;

export const useShortcut = (
  keys: Keys,
  callback: Callback,
  action?: string,
) => {
  const callbackRef = useRef<Callback>(callback);

  useEffect(() => {
    if (keys !== null) {
      mousetrap.bind(keys, callbackRef.current, action);
    }

    return () => {
      if (keys !== null) {
        mousetrap.unbind(keys);
      }
    };
  }, [keys, action]);
};

export enum KeyMaps {
  NewTask = 'n',
  Home = 'h',
  Projects = 'p',
}
